/**
 * @generated SignedSource<<ea666323bd0d9e8bc77fe1d090358095>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DuplicateUrlMappingInput = {
  clientMutationId?: string | null;
  urlMappingId: string;
};
export type UrlMappingListTab_duplicateMutation$variables = {
  input: DuplicateUrlMappingInput;
};
export type UrlMappingListTab_duplicateMutationVariables = UrlMappingListTab_duplicateMutation$variables;
export type UrlMappingListTab_duplicateMutation$data = {
  readonly duplicateUrlMapping: {
    readonly urlMapping: {
      readonly id: string;
    };
  } | null;
};
export type UrlMappingListTab_duplicateMutationResponse = UrlMappingListTab_duplicateMutation$data;
export type UrlMappingListTab_duplicateMutation = {
  variables: UrlMappingListTab_duplicateMutationVariables;
  response: UrlMappingListTab_duplicateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DuplicateUrlMappingPayload",
    "kind": "LinkedField",
    "name": "duplicateUrlMapping",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UrlMapping",
        "kind": "LinkedField",
        "name": "urlMapping",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UrlMappingListTab_duplicateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UrlMappingListTab_duplicateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "da430cd043d0006cb2442d0d0b536040",
    "id": null,
    "metadata": {},
    "name": "UrlMappingListTab_duplicateMutation",
    "operationKind": "mutation",
    "text": "mutation UrlMappingListTab_duplicateMutation(\n  $input: DuplicateUrlMappingInput!\n) {\n  duplicateUrlMapping(input: $input) {\n    urlMapping {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "50d70fcb9aeb554cf69cf66cbfd1c9af";

export default node;
